import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { AuctionDetailStoreContext } from '../contexts/StoreContext'
import { AuctionDetailStore } from '../store/interface'

export const useAuctionDetailStore: UseStore<AuctionDetailStore> = seletor => {
  return useContextStore(AuctionDetailStoreContext, seletor)
}

export const useAuctionDetailStoreApi = () => {
  return useContextStoreApi(AuctionDetailStoreContext)
}
